import { useT } from '@/i18n/useT';

export function Spinner() {
  return <div className="spinner" role="status" aria-label="loading" />;
}

/** Centered splash used while the initial session resolves. */
export function FullPageSpinner() {
  const { t } = useT();
  return (
    <div className="spinner-wrap">
      <div className="spinner" role="status" aria-label={t('common.loading')} />
    </div>
  );
}
